import { Button } from '@mui/material'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

function SplitPaymentButton() {
    const { t } = useTranslation()
    const { onSetSplitPayment, isSaleComplete } = usePaymentContext()
    const onClickSplit = useCallback(() => {
        onSetSplitPayment(true)
    }, [onSetSplitPayment])

    return (
        <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onClickSplit}
            disabled={isSaleComplete}
        >
            {t('finish.button.split_payment')}
        </Button>
    )
}

export default SplitPaymentButton
